<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          Trazabilidad de Producto
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="8" sm="8" md="8">
              <v-text-field
                dense
                v-model="filtroproducto"
                @change="cargarproducto(filtroproducto)"
                label="Filtrar Código de producto"
              >
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="1">
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="red lighten-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="showCamera"
                  >
                    Scan
                    <v-icon dark right>
                      mdi-camera
                    </v-icon>
                  </v-btn>
                </template>
                <div class="container">
                  <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card
                      elevation="24"
                      max-width="400"
                      class="mx-auto"
                      color="#00BB2D"
                      dark
                      raised
                    >
                      <v-card-title class="headline layout justify-center"
                        >Lector de Código QR
                        <p class="error">{{ error }}</p>

                        <p class="decode-result">
                          Último resultado: <b>{{ result }}</b>
                        </p></v-card-title
                      >
                      <v-container>
                        <v-row dense>
                          <v-col cols="12">
                            <StreamBarcodeReader
                              v-if="isview"
                              @close="onClosed"
                              @decode="onDecode"
                              @loaded="onLoaded"
                            ></StreamBarcodeReader>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-form>
                </div>
              </v-dialog>
              <!-- <v-icon large left @click="Buscarcodigo()">mdi-photo</v-icon> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <v-data-table
          dense
          :headers="headers"
          :items="listadoproducto"
          locale="es-ar"
          class="elevation-1"
          :items-per-page="20"
          :footer-props="{
            itemsPerPageText: 'Productos por página',
          }"
        >
        </v-data-table>
      </v-card>
    </v-app>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import axios from "../../../src/axios-auth";
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
  components: { StreamBarcodeReader },
  data: (vm) => ({
    valid: false,
    lazy: false,
    dialog: false,
    result: "",
    error: "",
    isview: false,
    editedItem: {},
    editedIndex: -1,
    filtroproducto: "",
    productos: [],
    listadoproducto: [],
    headers: [
      {
        text: "Serie",
        align: "start",
        sortable: false,
        value: "serie",
      },
      { text: "Tipo", value: "tipo" },
      { text: "Modelo", value: "modelo" },
      { text: "Producto", value: "producto" },
      { text: "Función", value: "funcion" },
      { text: "Nombre", value: "nombre" },
      { text: "Descripción", value: "descripcion" },
      { text: "OT", value: "ot" },
      { text: "Nom. OT", value: "nombreot" },
      { text: "Fecha", value: "fecha" },
    ],
  }),

  computed: {
    show: {
      get() {
        // this.cargarObras(false);
        this.$store.state.sector = "Producto";
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          //this.vaciarModels();
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    onClosed() {
      console.log("onClosed");
      this.isview = false;
    },
    showCamera() {
      return (this.isview = !this.isview);
    },
    onDecode(result) {
      this.filtroproducto = result;
      this.cargarproducto(result);
      this.isview = false;
      this.dialog = false;
    },
    onLoaded() {
      console.log("load");
    },
    cargarproducto(filtro) {
      let self = this;
      axios
        .get("/Producto/GetProducto", {
          params: {
            filtro: filtro,
          },
        })
        .then((response) => {
          self.listadoproducto = response.data;
        })
        .catch((error) => {
          self.listadoproducto = [];
        });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },
  },
};
</script>
